import Request from '../../../../services/request/request';
import TokenManager from '../../../../services/TokenManager';

const Queries = {
    /**
     * Get sign in events for user
     * 
     * @return Promise
     */
    getActivity(perPage = 10, nextPage = null) {
        return Request.get('/auth/activity', {
            perPage: perPage,
            nextPage: nextPage,
        }, {
                Authorization: 'Bearer ' + TokenManager.fromLocalStorage().AccessToken
            }).catch((err) => {
                if (err.Error) {
                    throw new Error(err.Error);
                }
            });
    },
}

export default Queries; 
